import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor() { }

    permissionExist(permission: string) {
        const value = localStorage.getItem("rolesPermissions");
        if (value != null) {
            const res = value.split(",");
            const index = res.indexOf(permission);
            if (index != -1) {
                return true;
            } else {
                return false;
            }
        }
    }
}
